/**
 * StatusDot Component
 * Pulsing or static status indicator dot
 */

import React from 'react';
import { HealthStatus } from '../types';
import styles from '../SystemHealth.module.css';

interface StatusDotProps {
  status: HealthStatus;
  size?: 'small' | 'medium' | 'large';
  showPulse?: boolean;
  className?: string;
}

export const StatusDot: React.FC<StatusDotProps> = ({
  status,
  size = 'medium',
  showPulse = true,
  className = ''
}) => {
  const shouldPulse = showPulse && status === 'healthy';

  const sizeClass = {
    small: styles.dotSmall,
    medium: styles.dotMedium,
    large: styles.dotLarge
  }[size];

  const statusClass = {
    healthy: styles.dotHealthy,
    degraded: styles.dotDegraded,
    error: styles.dotError,
    loading: styles.dotLoading
  }[status];

  return (
    <span className={`${styles.statusDot} ${sizeClass} ${className}`}>
      <span className={`${styles.dotInner} ${statusClass}`} />
      {shouldPulse && (
        <span className={`${styles.dotPulse} ${statusClass}`} />
      )}
    </span>
  );
};

export default StatusDot;
